import { TreePine, GraduationCap, Users, TrendingUp, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const benefits = [{
  icon: TreePine,
  title: "More Room to Grow",
  description: "Explore homes with more space, larger yards, and neighborhoods designed for everyday living."
}, {
  icon: GraduationCap,
  title: "Strong Schools & Communities",
  description: "Access suburbs known for family-friendly environments, local events, and highly rated schools."
}, {
  icon: Users,
  title: "Parks, Trails & Downtowns",
  description: "Enjoy nearby parks, riverwalks, restaurants, shopping, and walkable community spaces."
}, {
  icon: TrendingUp,
  title: "Long-Term Value",
  description: "Find homes and communities that support both your lifestyle and long-term goals."
}];
export default function LifestyleBenefits() {
  return <section id="lifestyle-benefits" className="bg-muted/50 py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="flex flex-col order-2 lg:order-1">
            <div className="mb-10">
              <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">More Space For The Life You're <br />Building</h2>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-xl">Discover communities across Chicago’s western suburbs that offer comfort, convenience, strong schools, and room to grow</p>
            </div>

            <div className="flex flex-col gap-8 mb-10">
              {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex items-start gap-5 group">
                  <div className="shrink-0 mt-1 bg-background p-3.5 rounded-xl shadow-sm border border-border transition-colors group-hover:border-[var(--accent-gold)]/50">
                    <benefit.icon className="w-6 h-6" style={{
                  color: 'var(--accent-gold)'
                }} aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="font-default text-xl font-semibold text-foreground mb-2">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div>
              <Button asChild size="lg" className="gap-2">
                
              </Button>
            </div>
          </div>

          {}
          <div className="relative order-1 lg:order-2">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border border-border/50 bg-background">
              <img src="https://realestatewithanish.com/wp-content/uploads/2026/05/ChatGPT-Image-May-9-2026-03_20_19-PM-2.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/lifestyle-family-home.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/lifestyle-family-home.png-wvc-sizes" alt="Happy family enjoying their spacious new suburban home backyard" className="w-full h-auto object-cover lg:aspect-[3/4] hover:scale-105 transition-transform duration-700 ease-in-out" loading="lazy" />
            </div>
            
            {}
            <div className="absolute -bottom-12 -right-12 w-64 h-64 rounded-3xl opacity-20 -z-10" style={{
            backgroundColor: 'var(--accent-gold)'
          }} aria-hidden="true" />
          </div>

        </div>
      </div>
    </section>;
}